import { render, staticRenderFns } from "./MotorInsuranceRacqForm.vue?vue&type=template&id=32b047f2&"
import script from "./MotorInsuranceRacqForm.vue?vue&type=script&lang=js&"
export * from "./MotorInsuranceRacqForm.vue?vue&type=script&lang=js&"
import style0 from "./MotorInsuranceRacqForm.vue?vue&type=style&index=0&id=32b047f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports